import { request } from "./client.js";
import { E } from "./endpoints.js";
import type { RedeemInviteResponse } from "../types/invite.js";
import { redeemInviteResponseSchema } from "../schemas/invite.js";

/** POST /v1/lk/invites/redeem — json body { code } */
export async function redeem(code: string): Promise<RedeemInviteResponse> {
  return request(
    E.lk.invitesRedeem,
    { method: "POST", body: { code } },
    redeemInviteResponseSchema,
  );
}
